import { $can } from '@pendo/permissions';

export function hasManagementAccessForAppIds (ids) {
    return ids.some(
        (id) =>
            $can(id)
                .entity('applicationDetails')
                .action('view')
            || $can(id)
                .entity('installationSettings')
                .action('view')
            || $can(id)
                .entity('rawEvent')
                .action('view'),
    );
}
